import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=350a06f0&scoped=true&lang=html&"
import script from "./announcement.vue?vue&type=script&lang=js&"
export * from "./announcement.vue?vue&type=script&lang=js&"
import style0 from "./announcement.vue?vue&type=style&index=0&id=350a06f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a06f0",
  null
  
)

component.options.__file = "announcement.vue"
export default component.exports